import React, {useContext} from "react";
import './AllergensPopup.less';
import {TranslationsContext} from "../../../contexts/translations-context";
import {Button} from "../../elements/button/Button";
import {getSafeTranslation} from "../../../helpers/localization.helper";
import {DrawerDescription} from "../../elements/drawer-description/DrawerDescription";
import {DrawerPopup} from "../../dialog-layout/drawer-popup/DrawerPopup";

export const AllergensPopup = ({allergens, onDoneClick, onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('AllergensPopup.title', translations)}
		rightControl={<Button
			onClick={onDoneClick}
			isAutoWidth={false}
		>
			{getSafeTranslation('AllergensPopup.doneButtonCaption', translations)}
		</Button>
		}
		onOverlayClick={onOverlayClick}
	>
		<DrawerDescription text={allergens} isFullSize={true}/>

	</DrawerPopup>
}
